export enum TestSubscriptionOption {
    TestPortal1,
    TestPortal2,
    CSODTestPortal,
    SabaTestPortal
}